import React, { useEffect, useState } from "react";

const Spotify = () => {
  const [searchInput, setSearchInput] = useState("arijit singh");
  const [accessToken, setAccessToken] = useState("");
  const [albums, setAlbums] = useState([]);
  const [error, setError] = useState(null);

  const CLIENT_ID = "b11dd73c10934849a2416cbf9acc4f03";
  const CLIENT_SECRET = "069d1a631adf4bf0bfb4d54b4954ef5e";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authParameters = {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `grant_type=client_credentials&client_id=${CLIENT_ID}&client_secret=${CLIENT_SECRET}`,
        };

        const data = await fetch(
          "https://accounts.spotify.com/api/token",
          authParameters
        ).then((result) => result.json());

        setAccessToken(data.access_token);
        search();
      } catch (error) {
        setError("Error fetching access token");
      }
    };

    fetchData();
  }, []);

  const search = async () => {
    try {
      const searchParameters = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      };

      const response = await fetch(
        `https://api.spotify.com/v1/search?q=${searchInput}&type=artist`,
        searchParameters
      );
      const data = await response.json();

      if (data.artists && data.artists.items && data.artists.items.length > 0) {
        const artistID = data.artists.items[0].id;

        const albumsResponse = await fetch(
          `https://api.spotify.com/v1/artists/${artistID}/albums?include_groups=album&market=US&limit=50`,
          searchParameters
        );
        const albumsData = await albumsResponse.json();

        if (albumsData.items && albumsData.items.length > 0) {
          setAlbums(albumsData.items);
        } else {
          setAlbums([]);
          setError("No albums found");
        }
      } else {
        setAlbums([]);
        setError("Artist not found");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="p-2 bg-white animate-fadeIn">
      <div className="my-3 ml-5">
        <h1 className="text-center text-4xl pb-2 font-bold">Spotify Albums</h1>
        <div className="text-center">
          <p className="text-lg text-gray-600 mb-4">
            Search for your favorite artist and explore their albums.
          </p>
          <div className="flex justify-center items-center">
            <input
              className="border border-black px-4 py-2 rounded-md mr-2 focus:outline-none"
              placeholder="Search for artist"
              type="text"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
            <button
              onClick={search}
              className="bg-blue-950 hover:bg-blue-900 text-white font-semibold py-2 px-4 rounded focus:outline-none"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      {error && <div className="text-center text-red-600 mt-4">{error}</div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-5">
        {albums.length > 0 ? (
          albums.map((album, i) => (
            <div
              key={i}
              className="group mx-2 grid max-w-screen-md grid-cols-1 space-x-8 overflow-hidden rounded-lg border text-gray-700 shadow transition hover:shadow-lg"
            >
              <a
                href={album.external_urls.spotify}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={album.images[0].url}
                  alt=""
                  className="h-full w-full border-none object-cover text-gray-700 transition group-hover:scale-105"
                />
              </a>
              <div className="p-4">
                <h3 className="font-semibold text-lg mb-2">{album.name}</h3>
                <a
                  href={album.external_urls.spotify}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[16px] text-[#1DB954] hover:underline"
                >
                  Listen on Spotify
                </a>
              </div>
            </div>
          ))
        ) : (
          <div className="text-center">No albums found</div>
        )}
      </div>
    </div>
  );
};

export default Spotify;
